module.exports = __webpack_public_path__ + "img/razzo.87988a44.jpg";